import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import CarLicenseFrontDeskList from './components/CarLicenseFrontDeskList'


const { Cell } = ResponsiveGrid;

const CarLicenseFrontDesk = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="車牌預約前台"
        breadcrumbs={[
          {
            name: '車牌預約',
          },
          {
            name: '車牌預約前台',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <CarLicenseFrontDeskList />
    </Cell>
  </ResponsiveGrid>
);

export default CarLicenseFrontDesk;
